import React from "react";
import { FaDiscord, FaFacebook, FaFacebookMessenger, FaLaptopCode, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="px-4 py-10" style={{ background: "var(--surface-strong)", borderTop: "1px solid var(--border)" }}>
      <div className="home-container flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
        <div>
          <p className="text-sm font-semibold">GUBCPC</p>
          <p className="mt-1 text-xs home-muted">All rights reserved.</p>
        </div>

        <div className="flex flex-wrap gap-2">
          <a href="https://discord.gg/6xhH5vQQ" target="_blank" rel="noreferrer" className="home-btn-secondary px-3 py-2 text-sm">
            <FaDiscord className="inline" /> Discord
          </a>
          <a href="https://m.me/j/AbY0sOsnenSr4_p7/" target="_blank" rel="noreferrer" className="home-btn-secondary px-3 py-2 text-sm">
            <FaFacebookMessenger className="inline" /> Messenger
          </a>
          <a href="https://www.facebook.com/gubcpc" target="_blank" rel="noreferrer" className="home-btn-secondary px-3 py-2 text-sm">
            <FaFacebook className="inline" /> Facebook
          </a>
          <a href="https://www.linkedin.com/company/gubcpc/" target="_blank" rel="noreferrer" className="home-btn-secondary px-3 py-2 text-sm">
            <FaLinkedin className="inline" /> LinkedIn
          </a>
          <a href="https://greenoj.bd" target="_blank" rel="noreferrer" className="home-btn-secondary px-3 py-2 text-sm">
            <FaLaptopCode className="inline" /> GreenOJ
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
